import React from 'react';
import PropTypes from 'prop-types';

const Switch = ({ className, name, value, onChange, disabled, title }) => {

  const handleChange = (event) => {

    var name = event.target.name;
    var value = event.target.checked;

    onChange(name, value);
  };

  if (title != '') {
    return <label className={`form-check form-switch ${className}`}>
      <input type="checkbox" className="form-check-input" name={name} checked={value} disabled={disabled} onChange={handleChange} />
      <span className="form-check-label position-static">{title}</span>
    </label>
  }

  return <label className={`form-check form-check-single form-switch ${className}`}>
    <input type="checkbox" className="form-check-input" name={name} checked={value} disabled={disabled} onChange={handleChange} />
  </label>
}

export default Switch;

Switch.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
  title: PropTypes.string,
}
